module.exports = __webpack_public_path__ + "static/img/Planificaciones_8_descárgala a tu pc@4x.52d2f03a.png";